import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Actv from './part/Actv';
import Crr from './part/Crr';
import Acbg from './part/Acbg';
import ExpertAuditDetailController from '../../../controllers/expert/register/ExpertAuditDetailController';
import { ModalContext, useGlobalStore } from '../../../components/contexts';
import ValidateService from '../../../services/ValidateService';
import { dbForm, dbPost } from '../../../apis/commonApi';
import FileUpload from '../../../components/modalComponents/FileUpload';

const ExpertRegister = () => {
  const navigate = useNavigate();

  const [userRole, setRole] = useState(false);
  const { store } = useGlobalStore();

  const [valueList, setValueList] = useState({});

  const location = useLocation();
  const { rowData } = location.state || {};

  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const [rowInfo, setRowInfo] = useState({});

  const [statusOption, setStatusOption] = useState([]);

  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadList, setUploadList] = useState([]);
  const [sharedFileId, setSharedFileId] = useState('');

  const [isReadOnly, setReadOnly] = useState(false);

  const textAreaRef = useRef([]);

  const [trashSeq, setTrash] = useState([]); // 삭제 행 seq 저장 배열

  const [reason, setReason] = useState('');

  const controller = useMemo(() => {
    return new ExpertAuditDetailController(
      navigate,
      store,
      modalService,
      validateService,
      {
        userRole,
        setRole,
      },
      {
        valueList,
        setValueList,
      },
      {
        trashSeq,
        setTrash,
      },
      {
        selectedFiles,
        setSelectedFiles,
        setUploadList,
      },
      {
        statusOption,
        setStatusOption,
      },
      {
        rowInfo,
        setRowInfo,
      }
    );
  }, [store, modalService, validateService]);

  const fileUploadModal = () => {
    return (
      <FileUpload
        onClose={() => {
          setIsFileModalOpen(false);
          controller.settingRowInfo(null, null, null);
          setSharedFileId('');
          setSelectedFiles([]);
          setUploadList([]);
        }}
        dbPost={dbPost}
        dbForm={dbForm}
        onUpload={() => {}}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        uploadedFiles={uploadList}
        setUploadedFiles={setUploadList}
        sharedFileId={sharedFileId}
        setSharedFileId={setSharedFileId}
      />
    );
  };

  const reject = () => {
    return (
      <div className="tbl-wrap">
        <table className="tbl data row">
          <caption>전문가 심사 신청의 반려 사유를 나타내는 표입니다.</caption>
          <tbody>
            <tr>
              <th scope="row">반려사유</th>
              <td>
                <textarea
                  aria-label="반려사유"
                  rows={1}
                  className="form-control sm notClamp notResize"
                  ref={el => {
                    textAreaRef.current.push(el);
                  }}
                  value={valueList.rjctRsn || reason}
                  onChange={e => {
                    setReason(e.target.value);
                    e.target.style.height = 'auto';
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  readOnly={rowData.srngRsltCd === 'D'}
                  maxLength={4000}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const rejectRead = () => {
    return (
      rowData.srngRsltCd === 'D' || (userRole && rowData.srngRsltCd === 'P')
    );
  };

  const update = (item, key) => {
    const updateItem = { ...rowInfo.row, [key]: item };
    controller.updateList(rowInfo.part, rowInfo.rowIndex, updateItem);
  };

  const commonProps = {
    textAreaRef,
    setIsFileModalOpen,
    valueList,
    statusOption,
    controller,
    isReadOnly,
  };

  useEffect(() => {
    if (rowInfo.part) {
      const fileId = rowInfo.row.atchFileId;
      setSharedFileId(fileId);
      controller.getFileList(fileId).then();
    }
  }, [rowInfo]);

  useEffect(() => {
    if (rowInfo.part && sharedFileId) {
      update(sharedFileId, 'atchFileId');
      if (uploadList.length === 0) {
        update('', 'atchFileId');
        controller.fileIdUpdate().then();
      }
    }
  }, [sharedFileId, uploadList]);

  useEffect(() => {
    textAreaRef.current.forEach(textarea => {
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    });
  }, [valueList]);

  useEffect(() => {
    const list = ['C', 'P'];
    setReadOnly(userRole || list.includes(rowData.srngRsltCd));
  }, [userRole]);

  useEffect(() => {
    document.title = '전문가 심사 신청';
    if (controller.getRole()) {
      controller.adminElse();
      controller.fnOption().then();
      controller.fnSearch(rowData.entSn).then();
    } else {
      navigate('/');
    }
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 심사 신청</h2>
      </div>
      <div id="search-box" className="section">
        <div className="section__body">
          <div className="sch-option">
            <dl className="sch-option__item">
              <dt>요청자</dt>
              <dd>
                <div className="input__wrap">
                  <label htmlFor="exrtNm" hidden>
                    {rowData.exprtNm || valueList.exprtNm}
                  </label>
                  <input
                    className="form-control sm"
                    id="exrtNm"
                    name="exprtNm"
                    value={rowData.exprtNm || valueList.exprtNm}
                    placeholder="요청자"
                    readOnly
                  />
                </div>
              </dd>
            </dl>
            <dl className="sch-option__item">
              <dt>소속명</dt>
              <dd>
                <div className="input__wrap">
                  <label htmlFor="entNm" hidden>
                    {rowData.entNm || valueList.entNm}
                  </label>
                  <input
                    className="form-control sm"
                    id="entNm"
                    name="entNm"
                    value={rowData.entNm || valueList.entNm}
                    placeholder="소속명"
                    readOnly
                  />
                </div>
              </dd>
            </dl>
          </div>
          {!isReadOnly && (
            <div className="btn-group">
              <button
                type="button"
                className="btn sm"
                onClick={() => controller.fnSave('W')}
              >
                임시 저장
              </button>
              <button
                type="button"
                className="btn sm"
                onClick={() => controller.fnSave('P')}
              >
                심사 신청
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="section section-table">
        <Acbg {...commonProps} />
        <Crr {...commonProps} />
        <Actv {...commonProps} />
      </div>
      {isFileModalOpen && fileUploadModal()}
      {rejectRead() ? reject() : null}
      <br />
      {userRole && rowData.srngRsltCd === 'P' && (
        <div className="btn-group2">
          <button
            type="button"
            className="btn md"
            onClick={() => {
              reason.length > 0
                ? controller.updateStatus('D', rowData, reason)
                : modalService.noticeAlert('반려 시 사유를 입력 바랍니다.');
            }}
          >
            반려
          </button>
          <button
            type="button"
            className="btn md"
            onClick={() => controller.updateStatus('C', rowData)}
          >
            승인
          </button>
        </div>
      )}
    </>
  );
};

export default ExpertRegister;
